const React = require('react')
const { component } = require('../odo/odojs')
const inject = require('injectinto')
const route = require('odo-route')
const { useEffect } = require('react')

route('/sso/:type/', ({ params, querystring }) => {
  const r = { page: 'login:sso', type: params.type }
  querystring.split('&').forEach(p => {
    const [k, v] = p.split('=')
    r[k] = v
  })
  return r
})

inject.bind(
  'page:login:sso',
  component({
    render: (state, params, hub) => {
      const { type, email } = params

      document.title = 'Asset Altitude'

      useEffect(() => {
        if (type == 'azure-ad' && email) hub.emit('azure auth login', { type, email })
        else if (type == 'azure-ad' && window.location.hash) hub.emit('azure auth callback', { type })
      }, [])

      return <div className='page--wrapper'></div>
    }
  })
)
